const RENTS_LLD_PENDING = 'rents_lld_pending';
const RENTS_LLD_FAILED = 'rents_lld_failed';
const RENTS_LLD_DOWNLOADED = 'rents_lld_downloaded';
const RENT_LLD_DOWNLOADED = 'rent_lld_downloaded';
const RENT_BOOK_LLD_DOWNLOADED = 'rent_book_lld_downloaded';
const RENT_LLD_SENDING = 'rent_lld_sending';
const RENTS_LLD_RESET = 'rents_lld_reset';
export {
  RENTS_LLD_PENDING,
  RENTS_LLD_FAILED,
  RENTS_LLD_DOWNLOADED,
  RENTS_LLD_RESET,
  RENT_LLD_DOWNLOADED,
  RENT_BOOK_LLD_DOWNLOADED,
  RENT_LLD_SENDING
};



// WEBPACK FOOTER //
// ./src/store/rentsLld/types.js